<template>
  <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
    <!-- 这部分放你要渲染的那些内容 -->
    <swiper-slide v-for="(item,index) in items" :key="index">
      <img :src="item.img" class="index_img" @click="swiperLink(item)">
    </swiper-slide>
    <!-- 这是轮播的小圆点 -->
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>
 
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: { swiper, swiperSlide },
  props: {
    items: { type: Array, default: () => [] },
  },
  data: function () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        paginationClickable: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // autoplay:false,
        scrollbar: '.swiper-scrollbar',
        loop:true,//是否循环
        speed: 300,
        bannerUrl: '',
      },
    }
  },
  methods: {
    swiperLink(item){
    //   if(item.link){
    //     let w = window.open("about:blank")
    //     w.location.href=item.link
    //   }else{
	   switch (item.id) {
			case 1:
				this.$router.push('/pbf')
				break;
				case 2:
				this.$router.push('/jjfa?id=3')
				break;
				case 3:
		        this.$router.push('/jjfa?id=2')
				break;
				case 4:
				this.$router.push('/jjfa?id=1')
				break;
				case 6:
				this.$router.push('/pnyqx')
				break;
		 
			default:
				break;
		 }   
	//   }
    },
  },
  mounted() {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
}
</script>
 
<style scoped lang="less">
.index_img {
  width: 100%;
  min-width: 1200px;
}
.mySwiper {
  // position: relative;
}
// .swiper-pagination{
//     width: 10px;
//     height: 10px;
//     background: #ffffff;
//     position: absolute;
//     bottom: 20px;
//     left: 960px;
//     z-index: 10000;
// }
</style>


// WEBPACK FOOTER //
// src/components/banner/banner.vue